import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {
  public IsLogin: Subject<boolean> = new Subject<boolean>();
  constructor() { }


  setToken(token: string) {
    localStorage.setItem("loginToken", token)
  }

  setname(name: string) {
    localStorage.setItem("loginname", name);
  }

  getname() {
    return localStorage.getItem("loginname");
  }

  setSearchBar(searchKeywords: any) {
     localStorage.setItem("searchBarKeyword", searchKeywords);
  }

  getSearchKeyword() {
    return localStorage.getItem("searchBarKeyword");
  }

  removeSearchBar() {
    localStorage.removeItem("searchBarKeyword");
  }

  setUserRole(role: string) {
    localStorage.setItem("role", role);
  }

  static setId(id) {
    localStorage.setItem("tempId", id);
  }

  static getId() {
    return localStorage.getItem("tempId");
  }

  static getUserRole() {
    return localStorage.getItem("role");
  }

  getToken() {
    return localStorage.getItem("loginToken");
  }

  setUserId(userId: string) {
    localStorage.setItem("userId", userId)
  }

  static getUserId() {
    return localStorage.getItem("userId");
  }
  

  islogin() {
    if (this.getToken()) {
      this.IsLogin.next(true)
    } else {
      this.IsLogin.next(false)
    }
  }

  changeLoginStatus(_currentIsLogin: boolean) {

    this.IsLogin.next(_currentIsLogin)
  }

  setMenu(selectedMenu:string){
    localStorage.setItem("selectedMenu", selectedMenu);
  }

  getMenu(){
    return localStorage.getItem("selectedMenu");
  }

  removeMenu() {
    localStorage.removeItem("selectedMenu");
  }
  

  logout() {
    localStorage.setItem("languageId", null);
  }
}
